module.exports = __webpack_public_path__ + "static/media/mouse_down.a0249d35.mp3";